import { IconButton } from "@mui/material";
import { FieldArray, getIn, useFormikContext } from "formik";
import React from "react";
import {
  StyledFieldArrayQuickRowWrapper,
  StyledFieldArrayWrap,
} from "../Styles";
import {
  AppErrorMessage,
  AppFormField,
} from "../../../../../AppComponents/Forms";
import { AppMaterialIcons } from "../../../../../AppComponents/AppMaterialIcons";
import AppButton from "../../../../../AppComponents/AppButton";

interface Props {
  label?: string;
  name: string;
  tooltip?: any;
  divStyle?: any;
  sendValuesToParent?: (values: any) => void | undefined;
  children?: React.ReactNode;
  [otherProps: string]: any;
  disabled?: boolean;
}

const QuickReplyButtonFieldArray: React.FC<Props> = ({
  label,
  name,
  tooltip,
  divStyle,
  sendValuesToParent,
  disabled,
  children,
  ...otherProps
}) => {
  const { values, errors, touched } = useFormikContext<any>();
  console.log(values, "values");
  return (
    <StyledFieldArrayWrap style={divStyle}>
      <FieldArray name={name}>
        {({ insert, remove, push, swap, unshift, pop, replace }) => (
          <>
            {values &&
              name &&
              getIn(values, name)?.length > 0 &&
              getIn(values, name)?.map((item: any, index: number) => {
                const fieldName: string = `${name}.${index}.button_text`;
                return (
                  <>
                    <StyledFieldArrayQuickRowWrapper key={index.toString()}>
                      <AppFormField
                        label={`Quick Reply ${index + 1}`}
                        name={fieldName}
                        placeholder="Book now"
                        charactersLimit={20}
                        disabled={disabled}
                        id={
                          getIn(values, name)?.length > 1 &&
                          index + 1 === getIn(values, name)?.length
                            ? "add_button"
                            : ""
                        }
                      />

                      {/* Remove */}
                      <div className="removeBtnBox">
                        <IconButton
                          onClick={() => remove(index)}
                          disabled={
                            (getIn(values, name)?.length > 1 ? false : true) ||
                            disabled
                          }
                        >
                          <AppMaterialIcons iconName={"Delete"} />
                        </IconButton>
                      </div>
                    </StyledFieldArrayQuickRowWrapper>
                    <AppErrorMessage
                      error={getIn(errors, name)?.[index]?.name}
                      visible={getIn(touched, name)}
                      index={index}
                    />
                  </>
                );
              })}

            {/* Add new field at last position */}
            <AppButton
              variant="text"
              onClick={() =>
                push({
                  button_text: "Click now",
                  action_type: null,
                  url_type: "static",
                  url: "",
                  phone_number: "",
                })
              }
              style={{
                marginTop: "0.5rem",
                minWidth: "170px",
                width: "170px",
                border: "1px solid rgba(91, 115, 232, 1)",
                borderRadius: "6px",
              }}
              startIcon={"ri-add-line"}
              isDisabled={
                (getIn(values, name)?.length === 3 ? true : false) || disabled
              }
              id="add_button"
            >
              Add Button
            </AppButton>
          </>
        )}
      </FieldArray>
    </StyledFieldArrayWrap>
  );
};

export default QuickReplyButtonFieldArray;
